var user = {};
export {
  user as __exports
};
//# sourceMappingURL=user.js.map
